module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__vev_calendar-wrapper"
  }, [_c('cal-panel', {
    attrs: {
      "events": _vm.events,
      "calendar": _vm.calendarOptions,
      "selectedDay": _vm.selectedDayEvents.date
    },
    on: {
      "cur-day-changed": _vm.handleChangeCurDay,
      "month-changed": _vm.handleMonthChanged
    }
  }), _vm._v(" "), _c('cal-events', {
    attrs: {
      "title": _vm.title,
      "dayEvents": _vm.selectedDayEvents,
      "locale": _vm.calendarOptions.options.locale,
      "color": _vm.calendarOptions.options.color
    }
  }, [_vm._t("default", null, {
    showEvents: _vm.selectedDayEvents.events
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5698f75c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-event-calendar.vue
// module id = 16
// module chunks = 0